import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ConfirmationModal from '../../../../components/ConfirmationModal';
import Textarea from '../../../../components/Textarea';
import Dropzone from '../../../../components/Dropzone';
import { IMAGE_ASPECT_RATIO_ONE } from '../../../../utils/const';

const TeamCard = ({
  teammate,
  locales,
  locales: { portfolio },
  isFirstColorPallete,
  borderColorName,
  disabled = false,
}) => {
  const { image, imageCoords, name, description, position, id } = teammate;
  const {
    portfolioTeammate: {
      updatePortfolioTeammate,
      updatePortfolioTeammateImage,
      updatePortfolioTeammateImageCoords,
      removePortfolioTeammate,
    },
  } = useDispatch();

  const { uploadingImage } = useSelector((state) => state.portfolioTeammate);

  const onChange = (e) => {
    updatePortfolioTeammate({
      id,
      name: e.target.name,
      value: e.target.value,
    });
  };

  const onDropImage = ([file], openCropperHandler) => {
    updatePortfolioTeammateImage({
      id,
      name: 'image',
      blob: file,
      success: () => {
        openCropperHandler();
      },
    });
  };

  const onImageCropperSave = (croppedAreaPixels, innerCropData, zoom) => {
    updatePortfolioTeammateImageCoords({
      id,
      croppedAreaPixels,
      innerCropData,
      zoom,
      coords: imageCoords,
    });
  };

  return (
    <div className="team-current-card">
      <div className="header">
        {!disabled && (
          <ConfirmationModal
            body={locales.common.deleteConfirmation}
            confirmText="Delete"
            onConfirm={() => removePortfolioTeammate({ id })}
          >
            <div className="icon-section">
              <i className="icon-Delete" />
            </div>
          </ConfirmationModal>
        )}
      </div>
      <div className="image-hover">
        <Dropzone
          className="image-upload"
          onDrop={onDropImage}
          onCropperSave={onImageCropperSave}
          locales={locales}
          image={image}
          coords={imageCoords}
          uploading={uploadingImage === teammate.id}
          aspectRatio={IMAGE_ASPECT_RATIO_ONE}
          disabled={disabled}
          cropper
        />
      </div>

      <Textarea
        id="position"
        type="text"
        name="position"
        value={position}
        placeholder={portfolio.team.position}
        onChange={onChange}
        className="textarea-current textarea-current-team-card--position custom-font-body"
        delay={700}
        disabled={disabled}
      />
      <div
        className="fullName"
        style={{ borderBottomColor: !isFirstColorPallete && borderColorName }}
      >
        <Textarea
          id="fullName"
          value={name}
          onChange={onChange}
          placeholder={portfolio.team.fullName}
          name="name"
          type="text"
          className="textarea-current textarea-current-team-card--name custom-font-title"
          delay={700}
          disabled={disabled}
        />
      </div>

      <Textarea
        id="description"
        className="textarea-current textarea-current-team-card--description custom-font-body"
        name="description"
        placeholder={portfolio.page.descriptionPlaceholder}
        value={description}
        onChange={onChange}
        delay={700}
        disabled={disabled}
      />
    </div>
  );
};

export default TeamCard;
